import { useState } from 'react';
import { ButtonMain } from '@quero-delivery/quero-components-web';

import ModalConnectDelivery from './ModalConnectDelivery';
import type { Delivery } from '@/_features/deliveries/types';

interface ConnectDeliveryProps {
  delivery: Delivery;
  connectDeliveryToMotoboy(motoboyId: string): void;
  isActionLoading: boolean;
  disabled: boolean;
}

function ConnectDelivery({
  delivery,
  connectDeliveryToMotoboy,
  isActionLoading,
  disabled,
}: ConnectDeliveryProps) {
  const [isModalOpened, setIsModalOpened] = useState(false);

  return (
    <div style={{ cursor: 'default' }}>
      <ButtonMain
        textFirst="associar"
        tertiary
        onClick={event => {
          event.stopPropagation();
          setIsModalOpened(true);
        }}
        loading={isActionLoading}
        disabled={isActionLoading || disabled}
      />

      <ModalConnectDelivery
        opened={isModalOpened}
        loading={isActionLoading}
        disabled={isActionLoading || disabled}
        onClose={() => {
          setIsModalOpened(false);
        }}
        delivery={delivery}
        onConnect={connectDeliveryToMotoboy}
      />
    </div>
  );
}

export default ConnectDelivery;
